import { FC } from "react";
import BodyText from "../../../components/BodyText";

interface IProps {
  isMobile?: boolean
}

const QueueInfoText: FC<IProps> = ({isMobile}) => (
  <BodyText sx={{ color: "#F0EBE0", width: isMobile ? "100%" : "32%"}}>
    Hang tight! Your JrTrack is almost ready to go.
    Keep an eye on your inbox, we'll send you an email as soon as it's activated!
  </BodyText>
);

export default QueueInfoText;
